<c-container fluid class="p-4">
  <c-row>
    <c-col xs="12">
      <c-card class="mb-4">
        <c-card-header>
          <strong>{{ 'userStatistics.title' | translate }}</strong>
        </c-card-header>

        <c-card-body>
          <!-- Loading -->
          @if (loading()) {
            <div class="text-center py-5">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">{{ 'userStatistics.loading' | translate }}</span>
              </div>
            </div>
          }

          <!-- Error -->
          @if (error(); as err) {
            <div class="alert alert-danger" role="alert">
              {{ err }}
              <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadStatistics()">
                {{ 'userStatistics.retry' | translate }}
              </button>
            </div>
          }

          <!-- Statistics Matrix -->
          @if (!loading() && !error() && statisticsData() && activeLevels().length > 0) {
            @let periodsData = periods();
            @let levels = activeLevels();

            <!-- Legend -->
            <div class="mb-3 d-flex gap-3 flex-wrap legend-container">
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-success">{{ 'userStatistics.legend.active' | translate }}</span>
                <small class="legend-text">{{ 'userStatistics.legend.activeDesc' | translate }}</small>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-warning">{{ 'userStatistics.legend.inactive' | translate }}</span>
                <small class="legend-text">{{ 'userStatistics.legend.inactiveDesc' | translate }}</small>
              </div>
              <div class="d-flex align-items-center gap-2">
                <span class="badge bg-secondary">{{ 'userStatistics.legend.unconfirmed' | translate }}</span>
                <small class="legend-text">{{ 'userStatistics.legend.unconfirmedDesc' | translate }}</small>
              </div>
            </div>

            <div class="table-responsive">
              <table cTable [hover]="true" [striped]="true" class="statistics-matrix">
                <thead>
                  <tr>
                    <th class="sticky-col">{{ 'userStatistics.period' | translate }}</th>
                    <th class="sticky-col-2">{{ 'userStatistics.level' | translate }}</th>
                    <th class="text-center">{{ 'userStatistics.active' | translate }}</th>
                    <th class="text-center">{{ 'userStatistics.inactive' | translate }}</th>
                    <th class="text-center">{{ 'userStatistics.unconfirmed' | translate }}</th>
                    <th class="text-center fw-bold bg-light">{{ 'userStatistics.total' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  @for (periodData of periodsData; track periodData.period; let isFirst = $first) {
                    @for (level of levels; track level; let isFirstLevel = $first) {
                      <tr [class.border-top-bold]="isFirst && isFirstLevel">
                        @if (isFirstLevel) {
                          <td class="sticky-col fw-bold" [attr.rowspan]="levels.length">
                            {{ getPeriodLabel(periodData.period) | translate }}
                          </td>
                        }
                        <td class="sticky-col-2">
                          {{ 'userStatistics.level' | translate }} {{ level }}
                        </td>
                        <td class="text-center" [class]="getStatusClass(getLevelData(periodData, level).active)">
                          {{ getLevelData(periodData, level).active }}
                        </td>
                        <td class="text-center" [class]="getStatusClass(getLevelData(periodData, level).inactive)">
                          {{ getLevelData(periodData, level).inactive }}
                        </td>
                        <td class="text-center" [class]="getStatusClass(getLevelData(periodData, level).unconfirmed)">
                          {{ getLevelData(periodData, level).unconfirmed }}
                        </td>
                        <td class="text-center fw-bold bg-light"
                            [class]="getStatusClass(getLevelData(periodData, level).total)">
                          {{ getLevelData(periodData, level).total }}
                        </td>
                      </tr>
                    }

                    <!-- Total row for this period -->
                    <tr class="border-bottom-bold bg-totals">
                      <td class="sticky-col" *ngIf="levels.length > 0"></td>
                      <td class="sticky-col-2 fw-bold text-end">
                        {{ 'userStatistics.totals' | translate }}:
                      </td>
                      <td class="text-center fw-bold">
                        {{ getTotalForPeriod(periodData).active }}
                      </td>
                      <td class="text-center fw-bold">
                        {{ getTotalForPeriod(periodData).inactive }}
                      </td>
                      <td class="text-center fw-bold">
                        {{ getTotalForPeriod(periodData).unconfirmed }}
                      </td>
                      <td class="text-center fw-bold bg-primary text-white">
                        {{ getTotalForPeriod(periodData).total }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          <!-- No Data -->
          @if (!loading() && !error() && statisticsData() && activeLevels().length === 0) {
            <div class="text-center py-5">
              <p class="text-muted">{{ 'userStatistics.noData' | translate }}</p>
            </div>
          }
        </c-card-body>
      </c-card>
    </c-col>
  </c-row>
</c-container>